<template>
  <v-row justify="center">
    <v-dialog
      v-model="displaySelf"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ getTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-alert
            v-if="getMessage"
            :type="isWorkLevel ? 'warning': 'error'"
            prominent
          >
            {{ `Пользователь ${getMessage}` }}
          </v-alert>
          <v-subheader>
            <span
              style="font-size: large"
              class="mr-1"
            >{{ `Причина блокировки: ` }}</span>
            <span
              style="color: red"
            >{{ `${getReason}` }}</span>
          </v-subheader>

          <v-container>
            <v-row>
              <v-col
                cols="12"
                :sm="12"
              >
                <v-textarea
                  v-model="model.description"
                  label="Причина разблокировки"
                  required
                  hint="минимум 5 букв"
                  :error="!model.description"
                  persistent-hint
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="warning"
            text
            @click="$emit('onUnBlackListModalClose')"
          >
            Отменить
          </v-btn>
          <v-btn
            :color="'success'"
            text
            :disabled="!canSave"
            @click="save"
          >
            {{ isWorkLevel ? `Разблокировать` : 'Подтверждаю' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import BlackListMixin from '@/mixins/black-list-mixin'
import {
  BLACK_LIST_LEVEL_ORGANIZATION,
  BLACK_LIST_LEVEL_OFFICE,
} from '@/components/common/filter/black-list-level'
export default {
  name: 'UnBlackListModal',
  mixins: [BlackListMixin],
  props: {
    displaySelf: {
      type: Boolean,
      default: false,
    },
    saveCallback: {
      type: Function,
    },
    blackListEntry: {
      type: Object,
    }
  },
  data: () => ({
    model: {
      user: null,
      description: null,
    }
  }),
  computed: {

    // [
    //     {
    //       "id": "d23fdfc6-e9cd-4113-8a33-7335701f9972",
    //       "title": "Блокировка на 240 часа",
    //       "trustabilityPenaltyType": "Блокировка на 240 часа",
    //       "user": {
    //         "id": "6ab4e0de-3c0d-41cc-80bd-6f6b44b85538",
    //         "username": "79679197836",
    //         "fullName": "Фроловa Регина Власовa Сергей Львович"
    //       },
    //       "level": "organization",
    //       "type": "organization",
    //       "office": null,
    //       "organization": {
    //         "id": "7bab9115-6a17-4ebb-bb9f-0be9e2627169",
    //         "title": "АГРОТОРГ"
    //       },
    //       "description": null,
    //       "vacancy": null,
    //       "createdAt": "2023-06-01T14:54:56+00:00",
    //       "expiredAt": "2023-06-01T14:54:56+00:00"
    //     }
    //     ]
    getTitle () {
      const { trustabilityPenaltyType } = this.blackListEntry
      if (trustabilityPenaltyType) {
        return 'Досрочная разблокировка пользователя по надежности'
      }

      if (this.isOfficeLevel) {
        return 'Удаление из черного списка объекта'
      }
      if (this.isOrganizationLevel) {
        return 'Удаление из черного списка организации'
      }

      return 'Досрочная разблокировка пользователя'
    },
    isWorkLevel () {
      const { trustabilityPenaltyType } = this.blackListEntry

      return !!trustabilityPenaltyType
    },
    isOfficeLevel () {
      const { level } = this.blackListEntry

      return level === BLACK_LIST_LEVEL_OFFICE
    },
    isOrganizationLevel () {
      const { level } = this.blackListEntry

      return level === BLACK_LIST_LEVEL_ORGANIZATION
    },
    getReason () {
      const { description, title } = this.blackListEntry

      if (this.isWorkLevel && title) {
        return `Нарушение правила работы в системе. ${title}`
      } else if (description) {
        return description
      }
      return 'Не указана'
    },
    getMessage () {
      const { expiredAtString, trustabilityPenaltyType, level, office, organization } = this.blackListEntry
      const expiredText = expiredAtString ? ` заблокирован до ${expiredAtString}` : ''
      if (trustabilityPenaltyType) {
        return `Пользователь ${this.model.user.fullName} ${expiredText}`
      }
      if (level === BLACK_LIST_LEVEL_OFFICE && !!office && !!office.id) {
        return `Пользователь ${this.model.user.fullName} Заблокирован на объекте ${office.title}`
      }
      if (level === BLACK_LIST_LEVEL_ORGANIZATION) {
        return `Пользователь ${this.model.user.fullName} Заблокирован на организации ${organization.title}`
      }

      return null
    },
    canSave () {
      const { description, user } = this.model

      return user && user.id && description && description.trim().length >= 5
    },
  },
  created () {
    if (this.blackListEntry && this.blackListEntry.user) {
      this.model.user = this.blackListEntry.user
    }
  },
  methods: {
    onLaborerSelectorFilterChange (data) {
      this.model.user = data
    },
    async save () {
      try {
        // await this.proceedCreate(filter, this.saveCallback)
        await this.deleteBlackListEntry({
          ...this.blackListEntry,
          description: this.model.description
        }, this.saveCallback)
        this.$emit('onUnBlackListModalClose')
      } catch (error) {
        console.log(error)
        // this.$emit('onUserUnBlackListed')
      }
    }
  }
}
</script>
